// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"97fb95f0","977":"57e728f0"}[chunkId] + ".chunk.js";
};